import { render } from "./KioskOtp.vue?vue&type=template&id=05506f49&scoped=true"
import script from "./KioskOtp.vue?vue&type=script&lang=js"
export * from "./KioskOtp.vue?vue&type=script&lang=js"

import "./KioskOtp.vue?vue&type=style&index=0&id=05506f49&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05506f49"]])

export default __exports__